import React, { FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import { Link } from '../Link'
import { LinkText, Text } from '../Text'
import { Stack } from '../Stack'

import { UserPrimaryPhoto } from './UserPrimaryPhoto'

import { UserItem_user$key } from './__generated__/UserItem_user.graphql'

export const UserItem: FC<{
  user: UserItem_user$key
  displayFollowingMessage?: boolean
  textSize?: number
  photoSize?: number
  variant?: 'selectItem'
}> = ({
  user,
  displayFollowingMessage = true,
  textSize,
  photoSize,
  variant,
}) => {
  const data = useFragment(
    graphql`
      fragment UserItem_user on User
      @argumentDefinitions(
        displayFollowingMessage: { type: "Boolean!", defaultValue: true }
      ) {
        slugId
        firstName
        lastName

        followerCount

        ...UserPrimaryPhoto_user

        ...UserFollowingStatus_user
          @arguments(displayFollowingMessage: $displayFollowingMessage)
      }
    `,
    user
  )

  const content = (
    <Stack direction='horizontal' alignItems='center' gap={3}>
      <UserPrimaryPhoto user={data} size={photoSize} />

      {variant === 'selectItem' ? (
        <Text numberOfLines={1} size={textSize}>
          {data.firstName} {data.lastName}
        </Text>
      ) : (
        <Text numberOfLines={1} size={textSize}>
          {data.firstName} {data.lastName}
        </Text>
      )}
    </Stack>
  )

  if (variant === 'selectItem') {
    return content
  }

  return <Link to={`/${data.slugId}`}>{content}</Link>
}
